export const isJailBroken = () => {
  // No jailbreak functionality for web
  return false
}
